export function salesRepMap() {
  return {
    loading: false,
    selectedRegion: null,
    salesReps: [],
    error: '',
    showResults: false,
    regions: {
      // US States
      'AL': 'Alabama',
      'AK': 'Alaska',
      'AZ': 'Arizona',
      'AR': 'Arkansas',
      'CA': 'California',
      'CO': 'Colorado',
      'CT': 'Connecticut',
      'DE': 'Delaware',
      'FL': 'Florida',
      'GA': 'Georgia',
      'HI': 'Hawaii',
      'ID': 'Idaho',
      'IL': 'Illinois',
      'IN': 'Indiana',
      'IA': 'Iowa',
      'KS': 'Kansas',
      'KY': 'Kentucky',
      'LA': 'Louisiana',
      'ME': 'Maine',
      'MD': 'Maryland',
      'MA': 'Massachusetts',
      'MI': 'Michigan',
      'MN': 'Minnesota',
      'MS': 'Mississippi',
      'MO': 'Missouri',
      'MT': 'Montana',
      'NE': 'Nebraska',
      'NV': 'Nevada',
      'NH': 'New Hampshire',
      'NJ': 'New Jersey',
      'NM': 'New Mexico',
      'NY': 'New York',
      'NC': 'North Carolina',
      'ND': 'North Dakota',
      'OH': 'Ohio',
      'OK': 'Oklahoma',
      'OR': 'Oregon',
      'PA': 'Pennsylvania',
      'RI': 'Rhode Island',
      'SC': 'South Carolina',
      'SD': 'South Dakota',
      'TN': 'Tennessee',
      'TX': 'Texas',
      'UT': 'Utah',
      'VT': 'Vermont',
      'VA': 'Virginia',
      'WA': 'Washington',
      'WV': 'West Virginia',
      'WI': 'Wisconsin',
      'WY': 'Wyoming',
      'DC': 'Washington D.C.',
      // Canadian Provinces
      'AB': 'Alberta',
      'BC': 'British Columbia',
      'MB': 'Manitoba',
      'NB': 'New Brunswick',
      'NL': 'Newfoundland and Labrador',
      'NT': 'Northwest Territories',
      'NS': 'Nova Scotia',
      'NU': 'Nunavut',
      'ON': 'Ontario',
      'PE': 'Prince Edward Island',
      'QC': 'Quebec',
      'SK': 'Saskatchewan',
      'YT': 'Yukon'
    },

    init() {
      this.checkURLForRegion();
      
      this.$nextTick(() => {
        this.initializeSVGMapInteractions();
      });
      
      window.addEventListener('popstate', () => {
        this.checkURLForRegion();
      });
    },

    checkURLForRegion() {
      const urlParams = new URLSearchParams(window.location.search);
      const regionParam = urlParams.get('region');
      
      if (regionParam && (this.regions[regionParam.toUpperCase()] || regionParam.toLowerCase() === 'world')) {
        const regionCode = regionParam.toLowerCase() === 'world' ? 'world' : regionParam.toUpperCase();
        if (regionCode !== this.selectedRegion) {
          this.selectRegion(regionCode, false);
        }
      } else if (this.selectedRegion) {
        this.clearSelection(false);
      }
    },

    updateURL(regionCode) {
      const url = new URL(window.location);
      if (regionCode) {
        url.searchParams.set('region', regionCode.toLowerCase());
      } else {
        url.searchParams.delete('region');
      }
      window.history.pushState({}, '', url);
    },

    initializeSVGMapInteractions() {
      const allRegions = document.querySelectorAll('path[id^="US-"], path[id^="CA-"]');
      
      allRegions.forEach(region => {
        region.style.cursor = 'pointer';
        region.addEventListener('click', (e) => {
          e.preventDefault();
          const regionId = region.getAttribute('id');
          const regionCode = regionId.split('-')[1];
          this.selectRegion(regionCode);
        });
        
        region.addEventListener('mouseenter', (e) => {
          region.style.opacity = '0.7';
        });
        
        region.addEventListener('mouseleave', (e) => {
          if (!region.classList.contains('active')) {
            region.style.opacity = '1';
          }
        });
      });
    },

    async selectRegion(regionCode, updateURL = true) {
      if (this.loading) return;
      
      this.selectedRegion = regionCode;
      this.error = '';
      this.loading = true;
      this.showResults = false;
      
      if (updateURL) {
        this.updateURL(regionCode);
      }
      
      this.updateMapVisualState(regionCode);
      
      try {
        const response = await fetch(`/api/sales-reps/search-by-region?region=${regionCode}`);
        const data = await response.json();
        
        if (data.error) {
          this.error = data.error;
        } else {
          this.salesReps = data.salesReps || [];
          this.showResults = true;
          
          this.$nextTick(() => {
            const resultsSection = this.$refs.results;
            if (resultsSection) {
              const elementTop = resultsSection.offsetTop;
              const viewportHeight = window.innerHeight;
              const offset = viewportHeight * 0.15;
              
              window.scrollTo({
                top: elementTop - offset,
                behavior: 'smooth'
              });
            }
          });
        }
      } catch (error) {
        console.error('Error searching for sales reps:', error);
        this.error = 'Error searching for sales representatives. Please try again.';
      } finally {
        this.loading = false;
      }
    },

    getRegionName(code) {
      if (code === 'world') {
        return 'Rest of World';
      }
      return this.regions[code] || code;
    },

    updateMapVisualState(selectedRegionCode) {
      const allRegions = document.querySelectorAll('path[id^="US-"], path[id^="CA-"]');
      allRegions.forEach(region => {
        region.classList.remove('active');
        region.style.opacity = '1';
      });
      
      const selectedRegion = document.querySelector(`path[id="US-${selectedRegionCode}"], path[id="CA-${selectedRegionCode}"]`);
      if (selectedRegion) {
        selectedRegion.classList.add('active');
        selectedRegion.style.opacity = '0.7';
      }
    },

    clearSelection(updateURL = true) {
      this.selectedRegion = null;
      this.salesReps = [];
      this.showResults = false;
      this.error = '';
      
      if (updateURL) {
        this.updateURL(null);
      }
      
      const allRegions = document.querySelectorAll('path[id^="US-"], path[id^="CA-"]');
      allRegions.forEach(region => {
        region.classList.remove('active');
        region.style.opacity = '1';
      });
    }
  };
}